import React from 'react';
import { Utensils, ShoppingBag, Wrench, Briefcase, Sparkles, Church, Compass, Ship, Palmtree, Plane, HeartHandshake, Building2, Heart, Users, Camera, Video, Palette, Landmark, Clapperboard, Music } from 'lucide-react';

const categories = [
  { id: 'all', name: 'All', icon: null },
  { id: 'Restaurants', name: 'Restaurants', icon: Utensils },
  { id: 'Retail', name: 'Retail', icon: ShoppingBag },
  { id: 'Services', name: 'Services', icon: Wrench },
  { id: 'Professional', name: 'Professional', icon: Briefcase },
  { id: 'Beauty & Wellness', name: 'Beauty', icon: Sparkles },
  { id: 'Churches', name: 'Churches', icon: Church },
  { id: 'Non-Profits', name: 'Non-Profits', icon: HeartHandshake },
  { id: 'Foundations', name: 'Foundations', icon: Building2 },
  { id: 'Charities', name: 'Charities', icon: Heart },
  { id: 'Organizations', name: 'Organizations', icon: Users },
  { id: 'Photography', name: 'Photography', icon: Camera },
  { id: 'Videography', name: 'Videography', icon: Video },
  { id: 'Graphic Design', name: 'Graphic', icon: Palette },
  { id: 'Museums', name: 'Museums', icon: Landmark },
  { id: 'Film Production', name: 'Film', icon: Clapperboard },
  { id: 'Music Recording Company', name: 'Music Recording', icon: Music },
  { id: 'Adventures', name: 'Adventures', icon: Compass },
  { id: 'Cruises', name: 'Cruises', icon: Ship },
  { id: 'Vacation Rentals', name: 'Vacations', icon: Palmtree },
  { id: 'Travel Agencies', name: 'Travel', icon: Plane },
];

export const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap gap-2" data-testid="category-filter">
      {categories.map((category) => {
        const isActive = selectedCategory === category.id || (category.id === 'all' && !selectedCategory);
        const Icon = category.icon;

        return (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id === 'all' ? '' : category.id)}
            className={`
              flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium
              transition-all duration-200
              ${isActive
                ? 'bg-emerald-deep text-white shadow-lg shadow-emerald-900/20'
                : 'bg-white text-stone-600 border border-stone-200 hover:border-emerald-deep/30 hover:text-emerald-deep'
              }
            `}
            data-testid={`category-${category.id}`}
          >
            {Icon && <Icon className="w-4 h-4" />}
            <span>{category.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryFilter;
